import {
  PushPinOutlined, AccountBalance, Event, AttachMoney, AutoFixHigh, CalendarMonth, Campaign, ClassOutlined, ConfirmationNumberOutlined, Download, ExitToApp, Gavel, Grading, Groups, Insights, ManageAccounts, MeetingRoomOutlined, NoteAltOutlined, School, Settings, Store, SupportAgent, SwitchAccount, EventAvailable, EventBusy, HowToReg, Delete, PeopleAlt, Receipt, Edit, StickyNote2Outlined, WorkspacePremium, FormatListNumbered, PermMediaOutlined, BadgeOutlined, SmartphoneOutlined, EmailOutlined, ReceiptLongOutlined, HubOutlined } from "@mui/icons-material";

export const APP_ICONS = {
  ENROLMENTS: <ConfirmationNumberOutlined />,
  LOCATIONS: <Store />,
  SETTINGS: <Settings />,
  STUDENTS: <Groups />,
  CLASSES: <ClassOutlined />,
  // Sits beside CLASSES in the same tab bar, so it matches its weight rather than the outlined/
  // filled average of this list. A stack of media, not a paperclip: what a studio shares here is
  // video, photos, music and the occasional document.
  CLASS_FILES: <PermMediaOutlined />,
  SCHEDULE: <CalendarMonth />,
  STUDIOS: <MeetingRoomOutlined />,
  OPEN_ENROLMENTS: <AutoFixHigh />,
  SCHOOL: <School />,
  MY_PROFILE: <ManageAccounts />,
  SUPPORT: <SupportAgent />,
  SIGN_OUT: <ExitToApp />,
  CURRENCY: <AttachMoney />,
  LEGAL: <Gavel />,
  DANCE_SCHOOL_ACCOUNT: <AccountBalance />,
  ACCOUNTS: <SwitchAccount />,
  STAFF: <PeopleAlt />,
  METRICS: <Insights />,
  COMMUNICATION: <Campaign />,
  TEACHER_NOTES: <StickyNote2Outlined />,
  NOTICE_BOARD: <PushPinOutlined />,
  // The school's note TO an examiner. Deliberately not TEACHER_NOTES' StickyNote2Outlined:
  // the exams domain already has an examiner-authored per-cell note, and one shared icon for
  // two opposite directions of note would be unreadable on the scoring surface.
  EXAMINER_NOTES: <NoteAltOutlined />,
  TRIALS: <Event />,
  ATTENDANCE: <HowToReg />,
  ATTENDED: <EventAvailable />,
  DID_NOT_ATTEND: <EventBusy />,
  EMAIL_SETTINGS: <EmailOutlined />,
  DELETE: <Delete />,
  EDIT: <Edit />,
  DOWNLOAD: <Download />,
  // The Settings sub-tab bar is one deliberate set: six outlined glyphs of the same weight, each
  // repeated as the tab's own heading icon so a chip and the page it opens are visibly the same thing.
  // SCHOOL_PROFILE is an ID badge rather than a globe — the tab answers "who is this school", and the
  // globe read as "the internet". Note LOCATIONS already owns a storefront, and STUDIOS a door.
  SCHOOL_PROFILE: <BadgeOutlined />,
  DANCER_APP: <SmartphoneOutlined />,
  INVOICE_SETTINGS: <ReceiptLongOutlined />,
  BILLING_DETAILS: <AttachMoney />,
  INVOICES: <Receipt />,
  INTEGRATIONS: <HubOutlined />,
  EXAMS: <WorkspacePremium />,
  EXERCISES: <FormatListNumbered />,
  SCORES: <Grading />
}